/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function MetaLogo(props) {
  return (
    <svg
      {...props}
      width="104"
      height="48"
      viewBox="0 0 104 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162832)">
        <g clipPath="url(#clip1_18442_162832)">
          <path
            d="M3.414 27.849C3.414 29.0562 3.67897 29.9831 4.02531 30.5438C4.47939 31.2783 5.15667 31.5894 5.84714 31.5894C6.73771 31.5894 7.55243 31.3684 9.12248 29.197C10.3803 27.4565 11.8624 25.0135 12.8596 23.4819L14.5484 20.8871C15.7215 19.0851 17.0794 17.0818 18.6362 15.724C19.9072 14.6157 21.2783 14 22.6581 14C24.9747 14 27.1814 15.3425 28.8702 17.8603C30.7184 20.6177 31.6156 24.091 31.6156 27.6753C31.6156 29.8061 31.1956 31.3717 30.4809 32.6086C29.7904 33.8049 28.4447 35 26.1809 35V31.5894C28.1192 31.5894 28.603 29.8083 28.603 27.7698C28.603 24.865 27.9257 21.6414 26.4337 19.338C25.3749 17.7041 24.0028 16.7058 22.4932 16.7058C20.8605 16.7058 19.5466 17.9372 18.07 20.1329C17.285 21.2994 16.4791 22.721 15.5742 24.3252L14.5781 26.0898C12.577 29.6379 12.0702 30.446 11.0697 31.7796C9.31599 34.1149 7.8185 35 5.84714 35C3.50855 35 2.02976 33.9874 1.11389 32.4613C0.366249 31.2178 -0.000976562 29.5862 -0.000976562 27.727L3.414 27.849Z"
            fill="#0081FB"
          />
          <path
            d="M2.69092 18.101C4.25657 15.6877 6.516 14 9.10746 14C10.6082 14 12.1002 14.4442 13.6582 15.7163C15.3624 17.1071 17.1787 19.3973 19.4447 23.1718L20.2573 24.5264C22.2187 27.794 23.3347 29.4751 23.9878 30.2679C24.8278 31.286 25.416 31.5894 26.1801 31.5894C28.1185 31.5894 28.6023 29.8083 28.6023 27.7698L31.6148 27.6753C31.6148 29.8061 31.1948 31.3717 30.4802 32.6086C29.7897 33.8049 28.444 35 26.1801 35C24.7728 35 23.526 34.6943 22.1473 33.3937C21.0874 32.3953 19.8482 30.6219 18.895 29.0276L16.0595 24.2911C14.6367 21.914 13.3317 20.1417 12.5763 19.3391C11.7638 18.476 10.7193 17.4337 9.05249 17.4337C7.70343 17.4337 6.55778 18.3803 5.59903 19.8283L2.69092 18.101Z"
            fill="url(#paint0_linear_18442_162832)"
          />
          <path
            d="M9.05321 17.4337C7.70415 17.4337 6.5585 18.3803 5.59976 19.8283C4.2441 21.8745 3.414 24.9222 3.414 27.849C3.414 29.0562 3.67897 29.9831 4.02531 30.5438L1.11389 32.4613C0.366249 31.2178 -0.000976562 29.5862 -0.000976562 27.727C-0.000976562 24.3461 0.926982 20.8223 2.69164 18.101C4.2573 15.6877 6.51672 14 9.10819 14L9.05321 17.4337Z"
            fill="url(#paint1_linear_18442_162832)"
          />
          <path
            d="M38.2544 14.6641H42.2048L48.9215 26.8155L55.6393 14.6641H59.504V34.6306H56.2814V19.328L50.3904 29.9248H47.3669L41.477 19.328V34.6306H38.2544V14.6641ZM69.6016 22.1086C67.2905 22.1086 65.8985 23.848 65.5654 26.0019H73.4091C73.2474 23.7831 71.9676 22.1086 69.6016 22.1086ZM62.3703 27.2289C62.3703 22.6968 65.2993 19.3984 69.6576 19.3984C73.9445 19.3984 76.5041 22.6551 76.5041 27.4708V28.3558H65.5654C65.9535 30.6988 67.5082 32.2777 70.015 32.2777C72.0149 32.2777 73.265 31.6675 74.4503 30.5515L76.1621 32.6482C74.5492 34.1314 72.4976 34.9868 69.9006 34.9868C65.1828 34.9868 62.3703 31.5465 62.3703 27.2289ZM80.4116 22.3945H77.4452V19.7557H80.4116V15.3919H83.5209V19.7557H88.0277V22.3945H83.5209V29.0826C83.5209 31.3662 84.251 32.1776 86.0453 32.1776C86.8644 32.1776 87.3339 32.1073 88.0277 31.9918V34.602C87.1635 34.8461 86.3389 34.9582 85.4461 34.9582C82.0894 34.9582 80.4116 33.1243 80.4116 29.4531V22.3945ZM101.12 24.9607C100.496 23.384 99.1027 22.223 97.0555 22.223C94.3948 22.223 92.6917 24.1108 92.6917 27.186C92.6917 30.1843 94.2595 32.1633 96.928 32.1633C99.0258 32.1633 100.523 30.9429 101.12 29.4245V24.9607ZM104.23 34.6306H101.177V32.5481C100.324 33.7741 98.7718 34.9868 96.2573 34.9868C92.2134 34.9868 89.5109 31.6015 89.5109 27.186C89.5109 22.7287 92.2783 19.3984 96.4288 19.3984C98.4804 19.3984 100.09 20.2186 101.177 21.6666V19.7557H104.23V34.6306Z"
            fill="#192830"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_18442_162832"
          x1="6.70511"
          y1="26.8639"
          x2="28.4747"
          y2="27.9634"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0064E1" />
          <stop offset="0.4" stopColor="#0064E1" />
          <stop offset="0.83" stopColor="#0073EE" />
          <stop offset="1" stopColor="#0082FB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_18442_162832"
          x1="4.94667"
          y1="29.2827"
          x2="4.94667"
          y2="21.2565"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0082FB" />
          <stop offset="1" stopColor="#0064E0" />
        </linearGradient>
        <clipPath id="clip0_18442_162832">
          <rect width="104" height="48" fill="white" />
        </clipPath>
        <clipPath id="clip1_18442_162832">
          <rect
            width="104.23"
            height="21"
            fill="white"
            transform="translate(-0.000488281 14)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

MetaLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default MetaLogo
